import { FormattedMessage } from "react-intl";
import styles from "./SampleFeatureTag.module.scss";
import { useProgramName } from "../../../routes/home/common/useProgramName.ts";
interface AssetWithFeatureFlags {
  sampleable?: boolean;
  coachMe?: boolean;
  totalAccess?: boolean;
  accessibilityClaims?: boolean;
}

export default function SampleFeatureTag({
  asset,
  programName,
}: {
  asset: AssetWithFeatureFlags;
  programName?: string | null;
}) {
  const programNameLabel = useProgramName(programName, true);

  const hasAnyFeature =
    asset.sampleable ||
    asset.coachMe ||
    asset.totalAccess ||
    asset.accessibilityClaims;

  if (!hasAnyFeature) {
    return null;
  }

  return (
    <div className={styles.sampleSearchTag}>
      {asset.sampleable && (
        <div className="vst-feature-tag  vst-feature-tag-type-free-ebook-sample">
          <FormattedMessage defaultMessage="Free eBook Sample" />
        </div>
      )}
      {asset.coachMe && (
        <div className="vst-feature-tag vst-feature-tag-type-coachme">
          <FormattedMessage defaultMessage="CoachMe Included" />
        </div>
      )}
      {asset.totalAccess && (
        <div className="vst-feature-tag vst-feature-tag-type-day-one-access">
          {programNameLabel}
        </div>
      )}
      {asset.accessibilityClaims && (
        <div className="vst-feature-tag vst-feature-tag-type-a11y">
          <FormattedMessage defaultMessage="Accessibility Claims" />
        </div>
      )}
    </div>
  );
}
